import React from 'react';
import {connect} from 'react-redux';

import MojitoCore from 'mojito/core';
import MojitoServices from 'mojito/services';
import MojitoApplications from 'mojito/applications';
import MojitoPresentation from 'mojito/presentation';
import MojitoModules from 'mojito/modules';

import {getConfigByContext} from '#core/utils/config-utils.js';

import {ApplicationConfig} from '#core/config/application-config.js';

const BannerPromotions = MojitoModules.Promotions.BannerPromotions;
const FlexPane = MojitoPresentation.Components.FlexPane;
const UIViewImplementation = MojitoCore.Presentation.UIViewImplementation;
const ApplicationMenu = MojitoApplications.Sports.ApplicationMenu;
const MainNavigationBar = MojitoApplications.Sports.MainNavigationBar;

const {selectUserInfo} = MojitoServices.UserInfo.selectors;
const {selectActiveFreeBets} = MojitoServices.UserBonuses.selectors;
const {selectLoginTime} = MojitoServices.Authentication.selectors;

const {LOCATION} = MojitoServices.Promotions.types;

class HeaderImpl extends UIViewImplementation {
    render() {
        const layout = this.style.layout === 'normal' ? this.style.normalLayout : this.style.compactLayout;

        return (
            <div>
                {!ApplicationConfig.isEmbedded ? (
                    <ApplicationMenu
                        config={layout.applicationMenu}
                        userInfo={this.props.userInfo}
                        freeBets={this.props.freeBets}
                    />
                ) : null}
                <FlexPane config={this.style.bannersWrapper}>
                    <BannerPromotions applicablePage={'homepage'} config={this.style.banners} />
                </FlexPane>
                <MainNavigationBar config={layout.mainNavigationBar} loginTime={this.props.loginTime} />
            </div>
        );
    }
}

HeaderImpl.getStyle = (config, mode, merge) => {
    const contextConfig = getConfigByContext(config, mode);

    const bannersWrapper = merge(
        {
            style: {
                margin: '0 auto',
                maxWidth: '1440px',
                padding: '16px 0 36px 0',
                justifyContent: 'center',
            },
        },
        contextConfig.bannersWrapper || {}
    );

    return merge(contextConfig, {
        bannersWrapper,
        banners: {
            locationId: LOCATION.TOP,
            reportLoadingStatus: true,
            view: {
                stacked: true,
                swiper: {
                    loop: false,
                    autoPlay: false,
                    centerViewableSlide: false,
                    lazyLoadBufferSize: 2,
                    minViewableBufferSize: 3,
                    style: {
                        gap: '8px',
                        padding: '2px 1px',
                        scrollPaddingLeft: '8px',
                        scrollPaddingRight: '8px',
                        width: '100%',
                        borderRadius: '8px',
                    },
                    slide: {
                        style: {
                            overflow: 'hidden',
                            height: '158px',
                            flexBasis: '420px',
                            flexGrow: 1,
                            aspectRatio: 'auto',
                            borderRadius: '8px',
                        },
                    },
                },
                container: {
                    style: {
                        display: 'block',
                        maxWidth: '100%',
                    },
                },
            },
        },
    });
};

const mapStateToProps = state => ({
    userInfo: selectUserInfo(state),
    freeBets: selectActiveFreeBets(state),
    loginTime: selectLoginTime(state),
});

export const HeaderComponent = connect(mapStateToProps)(HeaderImpl);
